import styled from 'styled-components';

import { space3XL, spaceXXL } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

const StyledHero = styled(Hero)`
  margin: ${space3XL} 0 ${spaceXXL};
`;

export const Styled = {
  Hero: StyledHero,
};
